<template lang='pug' src='./modal.pug'></template>

<script>
import { closeModal } from '@/methods'
import Form from 'components/form/form'
import Icon from 'components/icon/icon'
import ReferForm from 'components/form/form-refer/form-refer'

export default {
  mixins: [closeModal],
  components: {
    Form,
    Icon,
    ReferForm
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?14f59eac